export enum DeductionSource {
  Tax = 'tax',
  NetAmount = 'netAmount',
}
